import { Header, Logo, T, Box, RenderOnScreen, Spinner, List, HeaderSignIn, LinksProvider } from '@veracity/vui';
import { useLocation } from 'react-router-dom';
import { useUser } from '../api/auth'
import { mainLinks, appName, signInUrl, signOutUrl } from '../config';

const AppHeader = () => {
  const { pathname } = useLocation();
    const { user, isLoading, login, logout } = useUser();

    const links = mainLinks
    ?.filter(link => user || !link.authRequired)
    .map(link => ({ linkProps: { as: 'a', href: link.to }, text: link.text }))
    .map(link => ({
      ...link,
      isActive: pathname.startsWith(link.linkProps.href)
    }));

    const userInfo = {
            displayName: user?.name || 'User',
        };

    return (
        <LinksProvider>
            <Header w='100%' top={0} position='fixed' left={0} right={0} zIndex={200}>
            <Header.Content pr={2}>
                <Logo brand="dnv" url="/" />
                <Header.Divider mr={2} />
                <T fontFamily="DNV Display,Verdana,Geneva,Tahoma,sans-serif" fontSize="20px">
                    {appName}
                </T>
                <Box ml="auto" />
                <RenderOnScreen minWidth="lg">
                <Header.MainLinks links={links} />
                <Header.Divider ml={1} mr={2} />
                </RenderOnScreen>

                {isLoading ? (
                <Box mx={1}>
                    <Spinner size="lg" />
                </Box>
                ) : user ? (
                <Header.Account
                    sections={
                    <List isInteractive>
                        <List.Divider />
                        <List.Item as="a" href={signOutUrl} iconLeft="falSignOut" text="Sign out" onClick={logout} />
                    </List>
                    }
                    userInfo={userInfo}
                />
                ) : (
                <Box ml={2}>
                    <HeaderSignIn url={signInUrl} onClick={login} />
                </Box>
                )}

                <RenderOnScreen maxWidth="lg">
                <Header.Divider ml={2} />
                <Header.MobileToggle />
                <Header.MobileContent>
                    <Header.MainLinks links={links} />
                </Header.MobileContent>
                </RenderOnScreen>
            </Header.Content>
            </Header>
        </LinksProvider>
    );
};

export default AppHeader;